/** en-GB messages added by Phase 4 fix task FX5 (erasure gaps: notice signatures, e-mail log). Only that task edits this file. */
export const fx5EnGB = {
    'dp.notices.acceptances': 'Notices accepted',
    'dp.email.outbox': 'E-mails sent',
};
//# sourceMappingURL=fx5.js.map